'use client';

import React from 'react';
import { SLIDES } from './PresentationShell';

const SECTION_COLORS: Record<string, string> = {
  intro: '#4caf7d',
  journey: '#e8a030',
  student: '#4caf7d',
  school: '#a8d87a',
  partnership: '#e8a030',
  ambassador: '#4caf7d',
  close: '#f5c96a',
};

interface ProgressSidebarProps {
  slides: typeof SLIDES;
  activeSlide: number;
  onScrollTo: (index: number) => void;
}

export default function ProgressSidebar({ slides, activeSlide, onScrollTo }: ProgressSidebarProps) {
  return (
    <div className="fixed left-4 top-1/2 -translate-y-1/2 z-40 hidden xl:flex flex-col items-center gap-1.5">
      {slides.map((slide, index) => {
        const isActive = activeSlide === index;
        const isPast = index < activeSlide;
        const color = SECTION_COLORS[slide.section] || '#4caf7d';

        return (
          <button
            key={`progress-dot-${slide.id}`}
            onClick={() => onScrollTo(index)}
            title={slide.label}
            className="group relative flex items-center"
            aria-label={`Đến slide ${index + 1}: ${slide.label}`}
          >
            <div
              className={`progress-dot transition-all duration-300
                ${isActive ? 'active scale-125' : isPast ? 'opacity-60' : 'opacity-30 hover:opacity-70'}
              `}
              style={{
                backgroundColor: isActive ? color : isPast ? color : '#a0b8a8',
                width: isActive ? '10px' : '6px',
                height: isActive ? '10px' : '6px',
              }}
            />
            <div className="absolute left-6 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
              <div className="bg-[#1a3a2a] border border-[rgba(76,175,125,0.3)] rounded-md px-2.5 py-1 whitespace-nowrap">
                <span className="text-[11px] text-[#f0ede6] font-body">
                  <span className="tabular-nums text-[#4caf7d] mr-1.5">{String(index + 1).padStart(2, '0')}</span>
                  {slide.label}
                </span>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}